module.exports = __webpack_public_path__ + "assets/svg/Icons/32/timesheet-yellow-0d7dad.svg";